import React from "react";
import QuoteRequestModalLibrary from "./quote-request-modal-library"

export default class ProfilesCardsDumpster extends React.Component {



    constructor(props) {
        super(props)

        this.profiles = []
        if (this.props.profiles.length > 0) {
            this.profiles = this.props.profiles
        }
        this.profilesById = this.props.cards
        /*if (this.props.profiles.length > 0) {
            this.profiles = this.props.profiles
            this.profilesById = []
            this.profiles.map((profile, index) => {
                this.profilesById[profile.id] = "";
            })
            
        }*/

        this.code = this.props.code
        this.place = this.props.place
       /* this.state = {
             profilesById: this.profilesById
        }*/

    }

    /**async componentDidMount() {
        const localCode = this.code === 'dumpster' ? 'dumpster-rental' : this.code === 'comercial-trash-service' ? 'commercial-waste-management' : this.code
        return Promise.all(this.profiles.map((profile, index) => {
            return fetch('/pros/' + localCode + '/' + profile.id + '.html')
            .then(res => {
                return res.text();
            })
            .then(res => {
                const empiezaCon = res.startsWith("<div class=\"flex-head\">\n\t<div class=\"images")
                if (res.startsWith("<div class=\"flex-head\">\n\t<div class=\"images")) {
                    var profilesByIdAux = this.state.profilesById
                    res = res.replace(/\[place\]/g, this.place.name);
                    profilesByIdAux[profile.id] = res;
                    this.setState({
                        profilesById: profilesByIdAux
                    })
                    return profile
                }
                else {
                    throw new Error('Invalid card');
                }
                
            }).catch((error) => {
                profile.remove = 1
                return profile
            });
        })).then(() => this.forceUpdate())
    }**/


    addQuote = (id) => {

        if (this.code != 'comercial-trash-service') {
            let formCode = 'dumpsterQuoteRequest'
            if(this.code === 'junk-removal') {
                formCode = 'junkRemovalQuoteRequest'
            }
            return (<QuoteRequestModalLibrary
                showButton={true}
                startVisible={false}
                proid={id}
                ondeffCode={formCode}
                />)
            
        } 

        return <></>
    }

    addMobileQuoteTitle = () => {
        switch(this.code) {
            case 'comercial-trash-service':
                return (
                    <div className="item">
                        <span className="mobile-quote-title">Compare commercial waste providers and call to request a quote.</span>
                    </div>
                )
                break;
            case 'junk-removal':
                return (
                    <div className="item">
                        <span className="mobile-quote-title">Compare Junk Removal Quotes</span>
                        <div className="flex-footer">
                            <QuoteRequestModalLibrary
                                showButton={true}
                                startVisible={false}
                                ondeffCode='junkRemovalQuoteRequest'
                                mobileQuoteLabel='Get Quotes Now'
                            />
                        </div>
                    </div>
                )
                break;
            default: 
                return (
                    <div className="item">
                        <span className="mobile-quote-title">Compare Dumpster Rental Quotes</span>
                        <div className="flex-footer">
                            <QuoteRequestModalLibrary
                                showButton={true}
                                startVisible={false}
                                ondeffCode='dumpsterQuoteRequest'
                                mobileQuoteLabel='Get Quotes Now'
                            />
                        </div>
                    </div>
                )
                break;
        }
    }

    render() {
        return (
            <div className="items-grid prof dumpster">
                <div className="container">
                    <div id="profiles-cards-list" className="row">

                        <div style={{minHeight: 150 + 'px'}} itemscope="itemscope"  key="mainitem" className="col-12 mobile-only universal-card">
                            {this.addMobileQuoteTitle()}
                        </div>
                        {
                            //this.profiles.filter(item => item.remove != 1).map((profile, index) => {
                            this.profiles.filter(item => item.remove != 1).map((profile, index) => {
                               const pro = profile
                                return (
                                    <div data-proid={pro.id} itemscope="itemscope" itemtype="https://schema.org/LocalBusiness" key={index} className="card-pro-view col-12 col-md-6 col-lg-4 mb-5">
                                        <div data-id={pro.id} className="item" >
                                            {
                                            this.profilesById[pro.id] && <div dangerouslySetInnerHTML={{__html: this.profilesById[pro.id]}}>
                                              
                                            </div>
                                            }
                                            {this.code != 'comercial-trash-service' ? 
                                            <div className="flex-footer">
                                                {this.addQuote(pro.id)}
                                            </div>
                                            :
                                            <></>
                                            } 
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                   
                </div>
            </div>
        )
    }
}